import { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Building2, Users, User } from "lucide-react";
import { MyContext } from "../hooks/MyContextProvider";
import Logo from "../assets/Images/logo-bg.png";
import { sidebarData } from "../hooks/helper";
import { MapPin, Grid3X3 } from "lucide-react";

const MobileSidebar = () => {
  const navigate = useNavigate();
  const { user } = useContext(MyContext);
  const [activeMenu, setActiveMenu] = useState(null);
  const location = useLocation();
  const isAdmin = user?.role === "admin";
  console.log(isAdmin, "isAdmin");
  let menuItems = [
    {
      id: "Team ",
      label: "Team ",
      path: "/manage-teams",
      icon: Building2,
    },
    {
      id: "Player ",
      label: "Player ",
      path: "/manage-players",
      icon: User,
    },
    {
      id: "Manage Display",
      label: "Manage Display",
      path: "/manage-display",
      icon: Grid3X3,
    },

    // {
    //   id: "Profile",
    //   label: "Profile",
    //   path: "/profile",
    //   icon: User,
    // },
  ];

  // Remove "Manage Venue" from menuItems

  if (user?.role === "venueStaff" || user?.role === "venueManager") {
    menuItems = menuItems.filter(
      (item) => item.id === "Profile" || item.id === "Book Venue"
    );
  }

  return (
    <div>
      <nav
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#ffffff",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "8px 0 0px 0",
          zIndex: 1000,
          boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
        }}
        className="custom-mobile-sidebar"
        role="navigation"
        aria-label="Bottom navigation"
      >
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <button
              key={item.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 12px",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                position: "relative",
                minWidth: "60px",
                textDecoration: "none",
              }}
              onClick={() => navigate(item.path)}
              onMouseEnter={(e) => {
                // Hover effect - slightly scale up if not active
                if (!isActive) {
                  e.target.style.transform = "scale(1.05)";
                }
              }}
              onMouseLeave={(e) => {
                // Reset hover effect
                if (!isActive) {
                  e.target.style.transform = "scale(1)";
                }
              }}
              aria-label={`Navigate to ${item.label}`}
              aria-current={isActive ? "page" : undefined}
            >
              <IconComponent
                size={24}
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: isActive ? "#3b82f6" : "#6b7280",
                  textAlign: "center",
                  margin: 0,
                  transition: "color 0.2s ease-in-out",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                }}
                strokeWidth={1.5}
              />
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: isActive ? "#3b82f6" : "#6b7280",
                  textAlign: "center",
                  margin: 0,
                  transition: "color 0.2s ease-in-out",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileSidebar;
